"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var abstractComponent_1 = __importDefault(require("./abstractComponent"));
var constants_1 = require("./constants");
var bootstrap_1 = require("bootstrap");
var DropdownHover = /** @class */ (function (_super) {
    __extends(DropdownHover, _super);
    function DropdownHover() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    DropdownHover.prototype.init = function () {
        this.setSelector(constants_1.DATA_HEADER);
        if (this.getElement() === null) {
            return;
        }
        new bootstrap_1.Collapse(this.getElement(), {
            toggle: false,
        });
        var dropdowns = this.getElement().querySelectorAll("[".concat(constants_1.DATA_DROPDOWN, "]"));
        if (window.innerWidth >= constants_1.WINDOW_BREAKPOINT_LG) {
            dropdowns.forEach(function (item) {
                var itemLink = item.querySelector('a[data-bs-toggle]');
                var dropdownMenu = item.querySelector("[".concat(constants_1.DATA_DROPDOWN_MENU, "]"));
                item.addEventListener('mouseover', function () {
                    if (itemLink) {
                        itemLink.classList.add('show');
                        itemLink.setAttribute('aria-expanded', 'true');
                        dropdownMenu.classList.add('show');
                        dropdownMenu.setAttribute('data-bs-popper', 'none');
                    }
                });
                item.addEventListener('mouseleave', function () {
                    if (itemLink) {
                        itemLink.classList.remove('show');
                        itemLink.setAttribute('aria-expanded', 'false');
                        dropdownMenu.classList.remove('show');
                        dropdownMenu.removeAttribute('data-bs-popper');
                    }
                });
            });
        }
    };
    return DropdownHover;
}(abstractComponent_1.default));
exports.default = DropdownHover;
// @TODO set aria-expanded true/false for itemLink
// @TODO set data-bs-popper="none" for nextItem
